export const BASE_URL = import.meta.env.VITE_API_BASE_URL as string

export const URL_ADMIN_LOGIN = 'api/admin/login' as const
export const URL_ADMIN_ORDERS = 'api/admin/orders' as const
export const URL_ADMIN_TRANSACTIONS = 'api/admin/transactions' as const
export const URL_ADMIN_DASHBOARD = 'api/admin/users' as const
export const URL_ADMIN_DASHBOARD_REVENUE = 'api/admin/dashboard/revenue' as const
export const URL_ADMIN_EMAIL = 'api/admin/emails' as const
export const URL_ADMIN_CONTACTS = 'api/admin/contacts' as const
export const URL_ADMIN_CATEGORIES = 'api/admin/categories' as const
export const URL_ADMIN_SUBCATEGORIES = 'api/admin/product-subcategories' as const
export const URL_ADMIN_TYPES = 'api/admin/product-types' as const
export const URL_ADMIN_PRODUCTS = 'api/admin/product-requests' as const

export const URL_ADMIN_PAYMENT_METHODS = 'api/admin/payment-methods' as const
export const URL_ADMIN_PREPAYMENT_CONFIGS = 'api/admin/prepayment-configs' as const

export const ACCESS_TOKEN = 'access_token' as const
